import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0657364"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  title: "Our platform",
  overflow: "visible",
  height: "auto",
  width: "100vw",
  class: "eVjGHM"
}
const _hoisted_2 = { class: "hrKYkf hidden-xs-only" }
const _hoisted_3 = { style: {"display":"flex","position":"relative","justify-content":"space-around","flex":"1 1 100%","flex-direction":"column"} }
const _hoisted_4 = { class: "LargePlatform__Icon-sc-1tk5kw3-1 hnWyYS" }
const _hoisted_5 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Solutions", -1))
const _hoisted_8 = { class: "LargePlatform__Icon-sc-1tk5kw3-1 hnWyYS" }
const _hoisted_9 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Design", -1))
const _hoisted_12 = { class: "LargePlatform__Icon-sc-1tk5kw3-1 hnWyYS" }
const _hoisted_13 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Materials", -1))
const _hoisted_16 = { class: "LargePlatform__Icon-sc-1tk5kw3-1 hnWyYS" }
const _hoisted_17 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " NPI", -1))
const _hoisted_20 = { class: "LargePlatform__Icon-sc-1tk5kw3-1 hnWyYS" }
const _hoisted_21 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Testing", -1))
const _hoisted_24 = { class: "LargePlatform__Icon-sc-1tk5kw3-1 hnWyYS" }
const _hoisted_25 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Advanced engineering", -1))
const _hoisted_28 = { class: "LargePlatform__Icon-sc-1tk5kw3-1 hnWyYS" }
const _hoisted_29 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Smart automation", -1))
const _hoisted_32 = { class: "LargePlatform__Icon-sc-1tk5kw3-1 hnWyYS" }
const _hoisted_33 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Supply chain solutions", -1))
const _hoisted_36 = { class: "LargePlatform__Icon-sc-1tk5kw3-1 hnWyYS" }
const _hoisted_37 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Safeguarding IP", -1))
const _hoisted_40 = { class: "LargePlatform__Icon-sc-1tk5kw3-1 hnWyYS" }
const _hoisted_41 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_42 = ["src"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Quality mgt system", -1))
const _hoisted_44 = { class: "LargePlatform__Icon-sc-1tk5kw3-1 hnWyYS" }
const _hoisted_45 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_46 = ["src"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Impact", -1))
const _hoisted_48 = { class: "LargePlatform__Icon-sc-1tk5kw3-1 hnWyYS" }
const _hoisted_49 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_50 = ["src"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Innovation", -1))
const _hoisted_52 = { class: "LargePlatform__Icon-sc-1tk5kw3-1 hnWyYS" }
const _hoisted_53 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_54 = ["src"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Integrity", -1))
const _hoisted_56 = { class: "SmallPlatform__Icon-o7ixrn-1 bUAjfw" }
const _hoisted_57 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_58 = ["src"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Solutions", -1))
const _hoisted_60 = { class: "SmallPlatform__Icon-o7ixrn-1 bUAjfw" }
const _hoisted_61 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_62 = ["src"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Design", -1))
const _hoisted_64 = { class: "SmallPlatform__Icon-o7ixrn-1 bUAjfw" }
const _hoisted_65 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_66 = ["src"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Materials", -1))
const _hoisted_68 = { class: "SmallPlatform__Icon-o7ixrn-1 bUAjfw" }
const _hoisted_69 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_70 = ["src"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " NPI", -1))
const _hoisted_72 = { class: "SmallPlatform__Icon-o7ixrn-1 bUAjfw" }
const _hoisted_73 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_74 = ["src"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Testing", -1))
const _hoisted_76 = { class: "SmallPlatform__Icon-o7ixrn-1 bUAjfw" }
const _hoisted_77 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_78 = ["src"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Advanced engineering", -1))
const _hoisted_80 = { class: "SmallPlatform__Icon-o7ixrn-1 bUAjfw" }
const _hoisted_81 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_82 = ["src"]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Smart automation", -1))
const _hoisted_84 = { class: "SmallPlatform__Icon-o7ixrn-1 bUAjfw" }
const _hoisted_85 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_86 = ["src"]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Supply chain solutions", -1))
const _hoisted_88 = { class: "SmallPlatform__Icon-o7ixrn-1 bUAjfw" }
const _hoisted_89 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_90 = ["src"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Safeguarding IP", -1))
const _hoisted_92 = { class: "SmallPlatform__Icon-o7ixrn-1 bUAjfw" }
const _hoisted_93 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_94 = ["src"]
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Quality mgt system", -1))
const _hoisted_96 = { class: "SmallPlatform__Icon-o7ixrn-1 bUAjfw" }
const _hoisted_97 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_98 = ["src"]
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Impact", -1))
const _hoisted_100 = { class: "SmallPlatform__Icon-o7ixrn-1 bUAjfw" }
const _hoisted_101 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_102 = ["src"]
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Innovation", -1))
const _hoisted_104 = { class: "SmallPlatform__Icon-o7ixrn-1 bUAjfw" }
const _hoisted_105 = { style: {"--aspect-ratio":"(1/1)"} }
const _hoisted_106 = ["src"]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Integrity", -1))

import { reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OurPlatform',
  setup(__props, { expose: __expose }) {

const classObj = reactive<any[]>([
    { animate__fadeInUpBig: false, animate__fadeOutDown: true },
    { animate__fadeInUpBig: false, animate__fadeOutDown: true },
    { animate__fadeInUpBig: false, animate__fadeOutDown: true }
])

const setAnimate = (n: number, flag: boolean, bool: boolean) => {
    classObj[n].animate__fadeInUpBig = bool
    classObj[n].animate__fadeOutDown = !bool
}

__expose({
    setAnimate
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          id: "OurPlatform1",
          title: "Labs",
          class: _normalizeClass(["gEeORJ animate__animated", classObj[0]])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: require('@/assets/svg/1_Solutions-fe5ece7b0324ef2066db50bc3a23e33e.svg')
              }, null, 8, _hoisted_6)
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: require('@/assets/svg/2_Design-304db405e1f664ff5c550c31c8e7b39a.svg')
              }, null, 8, _hoisted_10)
            ]),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                src: require('@/assets/svg/3_Materials-6c49bccfd5212a4b657461b55425304b.svg')
              }, null, 8, _hoisted_14)
            ]),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("img", {
                src: require('@/assets/svg/4_NPI-818b0066eae37013fea5482fa749b31f.svg')
              }, null, 8, _hoisted_18)
            ]),
            _hoisted_19
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("img", {
                src: require('@/assets/svg/5_Testing-e3cc9dc7e0dc5d0252b3cccf9e48e608.svg')
              }, null, 8, _hoisted_22)
            ]),
            _hoisted_23
          ])
        ], 2),
        _createElementVNode("div", {
          id: "OurPlatform2",
          title: "Manufacturing",
          class: _normalizeClass(["eyIvbh animate__animated", classObj[1]])
        }, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("img", {
                src: require('@/assets/svg/1_Advanced_engineering-04751715a167abf9b9839eb9122c4250.svg')
              }, null, 8, _hoisted_26)
            ]),
            _hoisted_27
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("img", {
                src: require('@/assets/svg/2_Smart_automation-d9dbe6cd6516986ac2e1def0ae1f9ac5.svg')
              }, null, 8, _hoisted_30)
            ]),
            _hoisted_31
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("img", {
                src: require('@/assets/svg/3_Supply_chain_solutions-9fd9f79f38f792a98b2b2c51f5a870a5.svg')
              }, null, 8, _hoisted_34)
            ]),
            _hoisted_35
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("img", {
                src: require('@/assets/svg/4_Safeguarding_IP-559996c703c8ec245476e8d1841a3538.svg')
              }, null, 8, _hoisted_38)
            ]),
            _hoisted_39
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("img", {
                src: require('@/assets/svg/5_Quality_mgt_system-e567e5dd6303736cb252a59826836969.svg')
              }, null, 8, _hoisted_42)
            ]),
            _hoisted_43
          ])
        ], 2)
      ]),
      _createElementVNode("div", {
        id: "OurPlatform3",
        title: "Sustainability",
        class: _normalizeClass(["LargePlatform__FirstRow-sc-1tk5kw3-3 eAMZsL animate__animated", classObj[2]])
      }, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("img", {
              src: require('@/assets/svg/1_Impact-356065071c5fe58d015d4a49f9fa64ca.svg')
            }, null, 8, _hoisted_46)
          ]),
          _hoisted_47
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("img", {
              src: require('@/assets/svg/2_Innovation-2d73435cfc0f4432023d089130151e5e.svg')
            }, null, 8, _hoisted_50)
          ]),
          _hoisted_51
        ]),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("img", {
              src: require('@/assets/svg/3_Integrity-19d2942c5710ea8b868621dd0f541387.svg')
            }, null, 8, _hoisted_54)
          ]),
          _hoisted_55
        ])
      ], 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["hidden-sm-and-up SmallPlatform__RowWrapper-o7ixrn-0 lkvUIl", classObj[0] || classObj[1] || classObj[2]])
    }, [
      _createElementVNode("div", {
        id: "OurPlatform4",
        title: "Labs",
        class: _normalizeClass(["SmallPlatform__Row-o7ixrn-2 eDCSiE animate__animated", classObj[0]])
      }, [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("img", {
              src: require('@/assets/svg/1_Solutions-fe5ece7b0324ef2066db50bc3a23e33e.svg')
            }, null, 8, _hoisted_58)
          ]),
          _hoisted_59
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("img", {
              src: require('@/assets/svg/2_Design-304db405e1f664ff5c550c31c8e7b39a.svg')
            }, null, 8, _hoisted_62)
          ]),
          _hoisted_63
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("img", {
              src: require('@/assets/svg/3_Materials-6c49bccfd5212a4b657461b55425304b.svg')
            }, null, 8, _hoisted_66)
          ]),
          _hoisted_67
        ]),
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("img", {
              src: require('@/assets/svg/4_NPI-818b0066eae37013fea5482fa749b31f.svg')
            }, null, 8, _hoisted_70)
          ]),
          _hoisted_71
        ]),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("img", {
              src: require('@/assets/svg/5_Testing-e3cc9dc7e0dc5d0252b3cccf9e48e608.svg')
            }, null, 8, _hoisted_74)
          ]),
          _hoisted_75
        ])
      ], 2),
      _createElementVNode("div", {
        id: "OurPlatform5",
        title: "Manufacturing",
        class: _normalizeClass(["SmallPlatform__Row-o7ixrn-2 eiTUhw animate__animated", classObj[1]])
      }, [
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("img", {
              src: require('@/assets/svg/1_Advanced_engineering-04751715a167abf9b9839eb9122c4250.svg')
            }, null, 8, _hoisted_78)
          ]),
          _hoisted_79
        ]),
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("img", {
              src: require('@/assets/svg/2_Smart_automation-d9dbe6cd6516986ac2e1def0ae1f9ac5.svg')
            }, null, 8, _hoisted_82)
          ]),
          _hoisted_83
        ]),
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("img", {
              src: require('@/assets/svg/3_Supply_chain_solutions-9fd9f79f38f792a98b2b2c51f5a870a5.svg')
            }, null, 8, _hoisted_86)
          ]),
          _hoisted_87
        ]),
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("img", {
              src: require('@/assets/svg/4_Safeguarding_IP-559996c703c8ec245476e8d1841a3538.svg')
            }, null, 8, _hoisted_90)
          ]),
          _hoisted_91
        ]),
        _createElementVNode("div", _hoisted_92, [
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("img", {
              src: require('@/assets/svg/5_Quality_mgt_system-e567e5dd6303736cb252a59826836969.svg')
            }, null, 8, _hoisted_94)
          ]),
          _hoisted_95
        ])
      ], 2),
      _createElementVNode("div", {
        id: "OurPlatform6",
        title: "Sustainability",
        class: _normalizeClass(["SmallPlatform__Row-o7ixrn-2 hCfGtl animate__animated", classObj[2]])
      }, [
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("img", {
              src: require('@/assets/svg/2_Innovation-2d73435cfc0f4432023d089130151e5e.svg')
            }, null, 8, _hoisted_98)
          ]),
          _hoisted_99
        ]),
        _createElementVNode("div", _hoisted_100, [
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("img", {
              src: require('@/assets/svg/2_Innovation-2d73435cfc0f4432023d089130151e5e.svg')
            }, null, 8, _hoisted_102)
          ]),
          _hoisted_103
        ]),
        _createElementVNode("div", _hoisted_104, [
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("img", {
              src: require('@/assets/svg/3_Integrity-19d2942c5710ea8b868621dd0f541387.svg')
            }, null, 8, _hoisted_106)
          ]),
          _hoisted_107
        ])
      ], 2)
    ], 2)
  ]))
}
}

})